import { render, staticRenderFns } from "./campaign-list-item.vue?vue&type=template&id=2d6464c0"
import script from "./campaign-list-item.vue?vue&type=script&lang=js"
export * from "./campaign-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6464c0')) {
      api.createRecord('2d6464c0', component.options)
    } else {
      api.reload('2d6464c0', component.options)
    }
    module.hot.accept("./campaign-list-item.vue?vue&type=template&id=2d6464c0", function () {
      api.rerender('2d6464c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/campaign-scheduling/campaign-list-item.vue"
export default component.exports